import React, { useState, useContext, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import "./Footer.css";
import originallogo1 from "../../../Assets/Images/logo.png";
import originallogo2 from "../../../Assets/Images/logo.png";
import footericon1 from "../../../Assets/Images/footericon1.png";
import footericon2 from "../../../Assets/Images/footericon2.png";
import footericon3 from "../../../Assets/Images/footericon3.png";
import footericon4 from "../../../Assets/Images/footericon4.png";
import footericon5 from "../../../Assets/Images/iconwhats.png";
import footericon6 from "../../../Assets/Images/Mail.png";
import appstore from "../../../Assets/Images/AppSStore.png";
import googleplay from "../../../Assets/Images/googlePPlay.png";
import { Link } from "react-router-dom";
import { CompanyData, LangContext } from "../../../App";
import { API_ENDPOINT } from "../../../AppConfig";
import axios from "axios";
import string from "../../../Assets/Localization/Local";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

const MyMapComponent = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap defaultZoom={12} defaultCenter={props.defaultCenter}>
      {props.isMarkerShown && (
        <Marker
          position={{ lat: props.marker.latitude, lng: props.marker.longitude }}
        />
      )}
    </GoogleMap>
  ))
);

const Footer = (props) => {
  const { lang } = useContext(LangContext);
  const { data } = useContext(CompanyData);
  const [AllCategories, setAllCategories] = useState([]);
  const [SecondCategories, setSecondCategories] = useState([]);
  console.log("data in footer is ", data && data);
  useEffect(() => {
    fetchAllCategories();
  }, []);
  const fetchAllCategories = () => {
    let uri = `${API_ENDPOINT}/category?all=true`;

    axios
      .get(uri, {
        headers: {
          "Accept-Language": lang,
        },
      })
      .then((response) => {
        console.log("category defe--> ", response.data.data);
        let temp = {},
          arr = [],
          secondArr = [];

        for (let i = 0; i < response.data.data.length; i++) {
          temp = {
            name: response.data.data[i].name,
            id: response.data.data[i].id,
            hasChild: true,
          };
          if (i > 4 && secondArr.length < 4) {
            secondArr.push(temp);
          }
          if ((i === 0 || i > 0) && arr.length < 5) {
            arr.push(temp);
          }
          temp = {};
          console.log(
            "all categories in cond :",
            arr.length,
            i,
            (i === 0 || i > 0) && arr.length < 4
          );
          // else if(i=0&&arr.length<4)
        }

        setSecondCategories(secondArr);
        setAllCategories(arr);
      })
      .catch((error) => {});
  };
  let copy = "\u00A9";
  string.setLanguage(lang);
  let branch = JSON.parse(localStorage.getItem("Branch"));
  console.log("Branches ===>", branch);
  return (
    <div className="Footer-layout">
      <div className="Footer-layout-content">
        <Container fluid>
          <Row className="align-items-center">
            <Col lg="3" md="6" sm="6" xs="12">
              <div className="Footer-layout-logo  iconsfooter">
                <Link to="/Catch-It">
                  <img
                    src={lang === "ar" ? originallogo1 : originallogo2}
                    alt="logo"
                    className="logofooter"
                  />
                </Link>
                <div className="d-flex justify-content-center">
                  {console.log("Dataaaaaa:", data)}
                  <span style={{ width: "70%" }}>
                    حول شوبرز دوت او اي مرحبًا بكم في شوبرز - سوق الشرق الأوسط
                    عبر الإنترنت. نحن نربط الأشخاص والمنتجات -
                    {/* {data&&data.aboutUs[lang]} */}
                  </span>
                </div>
                <div className="d-flex justify-content-center mt-2">
                  {data && data.whatsappNumber !== "" ? (
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href={`https://api.whatsapp.com/send?phone=${
                        data && data.whatsappNumber
                      }`}
                    >
                      <img
                        src={footericon5}
                        alt="footericon"
                        className={lang === "ar" ? "ml-2" : "mr-2"}
                      />
                    </a>
                  ) : null}
                  {data &&
                  data.socialLinks.filter((item) => item.key === "TWITTER")
                    .length ? (
                    <a
                      rel="noopener noreferrer"
                      href={
                        data &&
                        data.socialLinks.filter(
                          (item) => item.key === "TWITTER"
                        )[0].value
                      }
                      target="_blank"
                    >
                      <img
                        src={footericon1}
                        alt="footericon"
                        className={lang === "ar" ? "ml-2" : "mr-2"}
                      />
                    </a>
                  ) : null}
                  {data &&
                  data.socialLinks.filter((item) => item.key === "INSTAGRAM")
                    .length ? (
                    <a
                      rel="noopener noreferrer"
                      href={
                        data &&
                        data.socialLinks.filter(
                          (item) => item.key === "INSTAGRAM"
                        )[0].value
                      }
                      target="_blank"
                    >
                      <img
                        src={footericon2}
                        alt="footericon"
                        className={lang === "ar" ? "ml-2" : "mr-2"}
                      />
                    </a>
                  ) : null}
                  {data &&
                  data.socialLinks.filter((item) => item.key === "GMAIL")
                    .length ? (
                    <a
                      rel="noopener noreferrer"
                      href={
                        data &&
                        data.socialLinks.filter(
                          (item) => item.key === "GMAIL"
                        )[0].value
                      }
                      target="_blank"
                    >
                      <img
                        src={footericon3}
                        alt="footericon"
                        className={lang === "ar" ? "ml-2" : "mr-2"}
                      />
                    </a>
                  ) : null}

                  {data &&
                  data.socialLinks.filter((item) => item.key === "FACEBOOK")
                    .length ? (
                    <a
                      rel="noopener noreferrer"
                      href={
                        data &&
                        data.socialLinks.filter(
                          (item) => item.key === "FACEBOOK"
                        )[0].value
                      }
                      target="_blank"
                    >
                      <img src={footericon4} alt="footericon" />
                    </a>
                  ) : null}
                </div>
              </div>
            </Col>
            <Col lg="2" md="6" sm="6" xs="12">
              <div className="Footer-layout-links">
                <h6>
                  <Link
                    to="/Catch-It"
                    onClick={() => props.handelPath("/Catch-It")}
                  >
                    {string.Home}
                  </Link>
                </h6>
                <h6>
                  <Link
                    to="/Catch-It/about-us"
                    onClick={() => props.handelPath("/Catch-It/about-us")}
                  >
                    {string.Aboutus}
                  </Link>
                </h6>
                <h6>
                  <Link
                    to="/Catch-It/contact-us"
                    onClick={() => props.handelPath("/Catch-It/contact-us")}
                  >
                    {string.Contactus}
                  </Link>
                </h6>
                <h6>
                  <Link
                    to="/Catch-It/usage"
                    onClick={() => props.handelPath("")}
                  >
                    {string.Usage}
                  </Link>
                </h6>
                <h6>
                  <Link
                    to="/Catch-It/Privacy"
                    onClick={() => props.handelPath("")}
                  >
                    {string.Privacy}
                  </Link>
                </h6>
                <h6>
                  <Link
                    to="/Catch-It/return-policy"
                    onClick={() => props.handelPath("")}
                  >
                    {string.returnPolicy}
                  </Link>
                </h6>
              </div>
            </Col>
            <Col
              lg="4"
              md="6"
              sm="12"
              xs="12"
              // style={{ display: "flex", justifyContent: "space-around" }}
              className="catSection"
            >
              <span className="contact-us" style={{ marginRight: "15%" }}>
                {" "}
                {string.Categories}
              </span>
              <div style={{ display: "flex", justifyContent: "space-around" }}>
                <div className="Footer-layout-links mt-3">
                  {AllCategories.map((element, index) => {
                    return (
                      <h6>
                        {console.log(
                          "AllCategoriesAllCategories:",
                          AllCategories
                        )}
                        <a
                          href={`/Catch-It/Categories/${element.id}`}
                          onClick={() => props.handelPath("/Catch-It")}
                        >
                          {element.name}
                        </a>
                      </h6>
                    );
                  })}
                </div>
                <div className="Footer-layout-links secondCategories mt-3">
                  {SecondCategories.map((element, index) => {
                    return (
                      <h6>
                        <a
                          href={`/Catch-It/Categories/${element.id}`}
                          onClick={() => props.handelPath("/Catch-It")}
                        >
                          {element.name}
                        </a>
                      </h6>
                    );
                  })}
                  {SecondCategories.length > 3 && (
                    <h6>
                      <a
                        style={{color:"black"}}
                        href={`/Catch-It/Categories/all`}
                        onClick={() => props.handelPath("/Catch-It")}
                      >
                        {string.showall}
                      </a>
                    </h6>
                  )}
                </div>
              </div>
            </Col>
            <Col lg="3" md="6" sm="6" xs="12">
              <span className="contact-us">{string.Contactusfooter}</span>
              <div className="Footer-layout-contact ">
                <div
                  className="Footer-layout-contact-parent"
                  style={{ color: "#43D661" }}
                >
                  <div className={lang === "ar" ? "ml-3" : "mr-3"}>
                    <i
                      className="fas fa-mobile-alt"
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`tel:${data && data.landlinePhone}`}
                    style={{ color: "#707070", textDecoration: "none" }}
                  >
                    <span style={{ direction: "ltr" }}>
                      {data && data.landlinePhone}
                    </span>
                  </a>
                </div>
                <div className="Footer-layout-contact-parent">
                  <div className={lang === "ar" ? "ml-3" : "mr-3"}>
                    <i className="fas fa-envelope"></i>
                  </div>
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={"mailto:someone@yoursite.com"}
                    style={{ color: "#707070", textDecoration: "none" }}
                  >
                    <span>{data && data.email}</span>
                  </a>
                </div>
                <div className="Footer-layout-contact-parent">
                  <div className={lang === "ar" ? "ml-3" : "mr-3"}>
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <div style={{ width: "80%" }}>
                    <p>{data && data.location && data.location.address}</p>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content footer-urls">
                <a href={data && data.androidUrl} target="_blank">
                  <img src={googleplay} alt="google" width="122" />
                </a>
                <a href={data && data.iosUrl} target="_blank">
                  <img src={appstore} alt="ios" width="120" />
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="Footer-layout-copyright">
        <span>
          {" "}
          {string.rights} {copy}
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://tech4lifebs.com/"
            style={{ color: "white" }}
          >
            Tech4Life
          </a>
        </span>
      </div>
    </div>
  );
};

export default Footer;
